module.exports = __webpack_public_path__ + "static/media/IAM Permission Checks.4a00767a.png";